import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { userAccountTypes } from '../../types/user';

import { Button, InputContainer } from '~COMPONENTS/';
import TextInput from '~COMPONENTS/formInputs/TextInput';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { filterList, history, sortList } from '~APP_UTIL/';

import {
  currentLocation,
  previousLocationWasReturnStatus,
  previousLocationWasReturnDetails
} from '../../orders/reducer';
import { setSelectedReturnId } from '../../orders/orderReturns/actions';
import { originatesFromReturnStatus } from '../../orders/orderReturns/reducer';

export class AccountList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      accountList: null
    };
  }

  componentDidMount() {
    const { accounts } = this.props;
    this.setAccountList(accounts);
  }

  componentDidUpdate(prevProps) {
    const { accounts } = this.props;
    const { accountList, searchTerm } = this.state;

    if (accounts && accounts.length > 0 && !searchTerm) {
      if (
        accounts.length !== accountList.length ||
        (accounts.length === accountList.length && prevProps.accounts[0].accountId !== accounts[0].accountId)
      ) {
        this.setAccountList(accounts);
      }
    }
  }

  setSearchTerm = searchTerm => this.setState({ searchTerm });

  setAccountList = accountList =>
    this.setState({
      accountList: sortList(accountList, 'accountName')
    });

  getNextLocation = () => {
    const {
      currentLocation,
      previousLocationWasReturnStatus,
      previousLocationWasReturnDetails,
      originatesFromReturnStatus
    } = this.props;
    if (/orders/g.test(currentLocation)) {
      if (
        /orders\/id/g.test(currentLocation) ||
        /orders\/returns\/id/g.test(currentLocation) ||
        /orders\/returns\/details\/id/g.test(currentLocation)
      ) {
        if (previousLocationWasReturnStatus || previousLocationWasReturnDetails || originatesFromReturnStatus)
          return '/orders/returns';
        return '/orders/status';
      }
    }
    return null;
  };

  updateList = inputValue => {
    const { accounts } = this.props;
    const filterBy = ['accountName', 'accountId'];
    const updatedList = filterList(accounts, filterBy, inputValue);

    this.setSearchTerm(inputValue);
    this.setAccountList(updatedList);
  };

  handleAccountClick = ({ id, accountName, accountId }) => {
    const { handleAccountClick, setSelectedReturnId } = this.props;

    setSelectedReturnId('');
    handleAccountClick({
      name: accountName,
      number: accountId,
      id
    });

    const nextLocation = this.getNextLocation();
    if (nextLocation) history.push(nextLocation);
  };

  render() {
    const { accountList, searchTerm } = this.state;

    return (
      <>
        <InputContainer
          label={new TranslatedCopy({ id: 'accountDropdown.search.label' }).toString()}
          isSearch
          extraClassName='search-input bg-secondary-grey pt2-sm prl5-sm'
          dataDesc='accountDropdown__search'
        >
          <TextInput
            type='text'
            autoComplete='off'
            name='accountDropdown__search'
            onChange={this.updateList}
            value={searchTerm}
          />
        </InputContainer>
        <ul className='accountInfo__list bg-secondary-grey pb2-sm pt1-sm prl5-sm u-full-width'>
          {accountList &&
            accountList.map(account => (
              <li className='bg-white' key={`accountDropDown-${account.accountId}`}>
                <Button
                  className='accountInfo__link mt3-sm mb3-sm pt4-sm pb4-sm prl4-sm p2-lg
                    body-3 ta-sm-l u-full-width'
                  onClick={() => this.handleAccountClick(account)}
                  data-desc={`accountDropdown__account_${account.accountId}`}
                >
                  <div className='u-no-ws-e'>
                    {account.accountId} {account.accountName}
                  </div>
                </Button>
              </li>
            ))}
        </ul>
      </>
    );
  }
}

AccountList.propTypes = {
  accounts: PropTypes.arrayOf(userAccountTypes),
  currentLocation: PropTypes.string.isRequired,
  handleAccountClick: PropTypes.func.isRequired,
  previousLocationWasReturnStatus: PropTypes.bool.isRequired,
  previousLocationWasReturnDetails: PropTypes.bool.isRequired,
  originatesFromReturnStatus: PropTypes.bool.isRequired,
  setSelectedReturnId: PropTypes.func.isRequired
};

AccountList.defaultProps = {
  accounts: null
};

const mapStateToProps = state => ({
  currentLocation: currentLocation(state),
  previousLocationWasReturnStatus: previousLocationWasReturnStatus(state),
  previousLocationWasReturnDetails: previousLocationWasReturnDetails(state),
  originatesFromReturnStatus: originatesFromReturnStatus(state)
});

const connector = connect(mapStateToProps, {
  setSelectedReturnId
});

export default connector(AccountList);
